package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.GetProduct
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.MediumContentTitle

@Composable
fun ProductTabDiscountInfo(
    selectedProduct: GetProduct?,
    updateNoDiscountPossible: (Boolean) -> Unit,
    updateEmployeeNetItems: (Boolean) -> Unit,
    updateEmployeeConsumption: (Boolean) -> Unit,
    windowSizeMode: WindowSizeModeEnum
) {
    Column(
        modifier = Modifier
            .margin(
                top = Dimen.largePadding
            )
    )
    {

        MediumContentTitle(
            title = Strings.current().discount,
            marginBottom = Dimen.extraSmallPadding,
        )

        CheckboxComponent(
            modifier = Modifier
                .margin(
                    top = Dimen.smallPadding,
                ),
            checkStatus = selectedProduct?.isNetto ?: false,
            title = Strings.current().noDiscountPossible,
            onChecked = {
                updateNoDiscountPossible(true)
            },
            onUnChecked = {
                updateNoDiscountPossible(false)
            },
        )

//        CheckboxComponent(
//            modifier = Modifier
//                .margin(
//                    top = Dimen.smallPadding,
//                    left = Dimen.normalPadding,
//                ),
//            checkStatus = selectedProduct?.isNettoForUser ?: false,
//            title = Strings.current().employeeNetItems,
//            fontSize = getGeneralItemRatio(
//                windowSizeMode=windowSizeMode,
//                size = FontSizes.mediumFontSize
//            ),
//            onChecked = {
//                updateEmployeeNetItems(true)
//            },
//            onUnChecked = {
//                updateEmployeeNetItems(false)
//            },
//        )
//
//        CheckboxComponent(
//            modifier = Modifier
//                .margin(
//                    top = Dimen.smallPadding,
//                    left = Dimen.normalPadding,
//                ),
//            checkStatus = selectedProduct?.isEmployeeArticle ?: false,
//            title = Strings.current().employeeConsumption,
//            fontSize = getGeneralItemRatio(
//                windowSizeMode=windowSizeMode,
//                size = FontSizes.mediumFontSize
//            ),
//            onChecked = {
//                updateEmployeeConsumption(true)
//            },
//            onUnChecked = {
//                updateEmployeeConsumption(false)
//            },
//        )


    }
}